import { render } from "./BodyFight.vue?vue&type=template&id=2cff13ca"
import script from "./BodyFight.vue?vue&type=script&lang=js"
export * from "./BodyFight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/windowOverlay/reportInfo/BodyFight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cff13ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cff13ca', __exports__)) {
    api.reload('2cff13ca', __exports__)
  }
  
  module.hot.accept("./BodyFight.vue?vue&type=template&id=2cff13ca", () => {
    api.rerender('2cff13ca', render)
  })

}


export default __exports__